module.exports = __webpack_public_path__ + "static/media/20th.78414fc6.png";